<template>
  <v-radio
    :label="label"
    :value="value" @input="v=>this.$emit('input', v)"
  >
    <slot></slot>
  </v-radio>
</template>

<script>
  export default {
    props: ['label', 'value'],
  }
</script>
